/**
 * 全局样式常量
 * 统一管理布局相关的尺寸变量
 */

// Header 高度常量
export const HEADER_HEIGHT = {
  desktop: "64px",
  tablet: "60px",
  mobile: "56px",
} as const;

// 媒体查询断点
export const BREAKPOINTS = {
  mobile: "599px",
  tablet: "1279px",
  desktop: "1024px",
} as const;

// 颜色主题
export const COLORS = {
  primary: "#1890ff",
  success: "#52c41a",
  warning: "#faad14",
  error: "#f5222d",
  info: "#1890ff",
  text: {
    primary: "#262626",
    secondary: "#8c8c8c",
    disabled: "#bfbfbf",
  },
  background: {
    primary: "#ffffff",
    secondary: "#fafafa",
    tertiary: "#f5f5f5",
  },
  border: {
    primary: "#d9d9d9",
    secondary: "#f0f0f0",
  },
} as const;

// 字体大小
export const FONT_SIZES = {
  xs: "12px",
  sm: "14px",
  base: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
  "3xl": "30px",
  "4xl": "36px",
} as const;

// 间距
export const SPACING = {
  xs: "4px",
  sm: "8px",
  base: "16px",
  lg: "24px",
  xl: "32px",
  "2xl": "48px",
  "3xl": "64px",
} as const;

// 圆角
export const BORDER_RADIUS = {
  none: "0",
  sm: "2px",
  base: "4px",
  lg: "8px",
  xl: "12px",
  full: "9999px",
} as const;

// 阴影
export const SHADOWS = {
  none: "none",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
} as const;

// 动画时长
export const TRANSITIONS = {
  fast: "0.15s",
  normal: "0.3s",
  slow: "0.5s",
} as const;

// 导出 CSS 变量字符串（用于 styled-components）
export const cssVars = {
  headerHeight: {
    desktop: HEADER_HEIGHT.desktop,
    tablet: HEADER_HEIGHT.tablet,
    mobile: HEADER_HEIGHT.mobile,
  },
  colors: COLORS,
  fontSizes: FONT_SIZES,
  spacing: SPACING,
  borderRadius: BORDER_RADIUS,
  shadows: SHADOWS,
  transitions: TRANSITIONS,
};
